import React from 'react';
import './App.css';
import SideNav from './components/SideNav';

function App() {
  return (
    <SideNav />
  );
}

export default App;
